module.exports = __webpack_public_path__ + "static/media/im-rahmen-web.65bbdf06.mp4";